export default __webpack_public_path__ + "static/media/83t.5837ebfa.jpg";